<template>
  <q-btn
      v-bind="$attrs"
      :color="color"
      class="btn btn__common btn__common--flat"
      :flat="$isDesktop && !outline"
      :outline="outline || !$isDesktop"
      no-caps
  >
    <template v-slot:loading>
      <slot name="loading" />
    </template>
    <slot />
  </q-btn>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    outline: {
      type: Boolean,
    },
  },
}

</script>
